import { Pagination } from 'types'

export const ALERT_TYPE_INITIAL_PAGINATION: Pagination = {
  page: 1,
  limit: 30,
  sort: {
    by: 'name',
    order: 'ASC',
  },
}
